import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProductWithVariants } from '../../api/apiProducts';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to update a product with variants in a single request
 */
export const useUpdateProductWithVariants = () => {
    const queryClient = useQueryClient();

    const { mutate: updateProductWithVariantsMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateProductWithVariants(id, data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['products'] });
            queryClient.invalidateQueries({ queryKey: ['product'] });
            toast.success(res?.data?.message || res?.message || 'Product updated successfully');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { updateProductWithVariantsMutate, isUpdating };
};
